import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {ContactusComponent} from '../contactus/contactus.component';
import {CommonDialogComponent} from '../commondialog/common-dialog.component';
import { IWGSharedService } from '../../shared/services/shared.service';

@Component({
  selector: 'app-iwg-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input() blurBg:boolean = false;
  currentDate = Date();
  constructor(public dialog: MatDialog, private sharedService: IWGSharedService) { }
  ngOnInit(): void {
    
  }
  showContactUs($event): void {
    this.sharedService.isBlurredBg.next(this.blurBg);
    $event.preventDefault();
    const dialogRef = this.dialog.open(ContactusComponent, {
      width: 'auto',
      backdropClass: 'footerpopup'
    });
    dialogRef.afterClosed().subscribe((res:any)=> {
      this.sharedService.isBlurredBg.next(false);
    });
  }

  showTermsOfUse($event): void {
    this.sharedService.isBlurredBg.next(this.blurBg);
    $event.preventDefault();
    const dialogRef = this.dialog.open(CommonDialogComponent, {
    });

    dialogRef.afterClosed().subscribe((res:any)=> {
      this.sharedService.isBlurredBg.next(false);
    });
  }

}
